import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { jobsToBuckets, keyToDate, keyToFormattedDate } from "../helpers";
import { useCampaigns, useJobs } from "../../state/Storage";
import { getUser } from "../../state/User";
import Pagination from "../utils/Pagination";
import JobPreview from "./JobPreview";
import Activity from "../utils/icons/Activity";

export default function Timeline() {
  const [error, setError] = useState(null);
  const user = getUser() as User;
  const [campaigns] = useCampaigns();
  const [jobs, sync, pagination] = useJobs();
  const history = useHistory();
  const buckets: JobsBucket[] = jobsToBuckets(jobs).sort((a, b) => {
    return keyToDate(b.key).getTime() - keyToDate(a.key).getTime();
  });

  if (!pagination.loading && buckets.length === 0) {
    return (
      <div className="layout mt3">
        <h2 className="tac">Timeline</h2>
        <p className="tac mb3">Your posts over time.</p>
        <p className="tac">You have no scheduled posts yet.</p>
      </div>
    );
  }

  return (
    <div className="layout mt3">
      <h2 className="tac">Timeline</h2>
      <p className="tac mb3">Your posts over time.</p>
      {error && <div className="error mt1">{error}</div>}
      <ul>
        {buckets.length > 0 &&
          buckets.map((bucket) =>
            renderJobs(bucket, user, campaigns, setError, history, sync)
          )}
      </ul>
      <Pagination pagination={pagination} />
    </div>
  );
}

function renderJobs(
  bucket: JobsBucket,
  user: User,
  campaigns: Post[],
  setError: Function,
  history: { push: Function },
  syncJobs: Function
) {
  const { jobs, key } = bucket;
  const engagements = jobs.reduce(
    (res, j) => (j.stats ? res + j.stats.engagements : res),
    0
  );

  return (
    <React.Fragment key={key}>
      <li>
        <div></div>
        <div className="op06 tac pr1">
          <small>
            {keyToFormattedDate(key)}
            {engagements > 0 ? (
              <span className="ib ml1">
                <Activity size={12} /> {engagements}
              </span>
            ) : null}
          </small>
        </div>
      </li>
      {jobs.map((j: Job) => {
        const post = campaigns.find((p) => p.id === j.postId);
        return (
          <JobPreview
            key={j.id}
            job={j}
            post={post as Post}
            user={user}
            setDeletionError={setError}
            onDelete={syncJobs}
          />
        );
      })}
    </React.Fragment>
  );
}
